import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { Capacitor } from '@capacitor/core';

import { loginStatusVar } from '@context';

export function OAuthPage() {
  const navigate = useNavigate();
  const loginStatus = useReactiveVar(loginStatusVar);

  React.useEffect(() => {
    // Web: cookies-based flow needs a session refetch here
    if (!Capacitor.isNativePlatform()) {
      loginStatusVar({
        ...loginStatusVar(),
        forceGetSession: true,
      });
    }
  }, []);

  React.useEffect(() => {
    if (loginStatus.isLoggedIn) {
      navigate('/', { replace: true });
    }
  }, [loginStatus.isLoggedIn, navigate]);

  return null;
}
